import PageLayout from "@/components/PageLayout";
import ContactSection from "@/components/ContactSection";
import SEO from "@/components/SEO";

export default function ContactPage() {
  return (
    <PageLayout>
      <SEO
        title="Contact Us — Order Lining Fabric | Mutha Paras & Co., Chickpet, Bangalore"
        description="Get in touch for bulk orders, shade matching & samples. Call +91 76248 53840, WhatsApp, or visit our Chickpet, Bangalore store by appointment."
        path="/contact"
      />
      <ContactSection />
    </PageLayout>
  );
}
